import React, { useEffect, useState } from 'react';
import { BarGraph } from '@gerdau/hefesto-mais-web';
import {
  Column,
  DataProps
} from '@gerdau/hefesto-mais-web/_shared/graph/graph.types';
import {
  IDuplicateData,
  IDuplicateState
} from '../../../../../store/ducks/dashboard/types';
import { formatCurrency } from '../../../../../utils/formatNumbers';
import { DuplicatesFooter } from './styles';

interface IDuplicatesChartProps {
  duplicatesState: IDuplicateState;
}

const DuplicatesChart: React.FC<IDuplicatesChartProps> = ({
  duplicatesState
}) => {
  const [graphData, setGraphData] = useState<{
    duePercent: number;
    openPercent: number;
  }>();

  const [columns, setColumns] = useState<Column[]>([
    {
      dataKey: 'open',
      dataKeyTitle: 'A vencer',
      colors: {
        variant: 'support-03',
        tone: '500'
      }
    },
    {
      dataKey: 'due',
      dataKeyTitle: 'Vencidas',
      colors: {
        variant: 'support-04',
        tone: '500'
      }
    },
    {
      dataKey: 'total',
      dataKeyTitle: 'Total',
      colors: {
        variant: 'support-04',
        tone: '500'
      }
    }
  ]);

  const [dataSource, setDataSource] = useState<DataProps[]>([
    { open: 0, due: 0 }
  ]);

  useEffect(() => {
    const initDuplicatesChart = (invoicesSummary: IDuplicateData) => {
      const total = Number(invoicesSummary.totalInvoice.replace(/,/g, ''));

      const dueInvoiceSum = Number(
        invoicesSummary.dueInvoiceSum.replace(/,/g, '')
      );
      const openInvoiceSum = Number(
        invoicesSummary.openInvoiceSum.replace(/,/g, '')
      );

      let duePercent = 0;
      let openPercent = 0;
      dueInvoiceSum > 0
        ? (duePercent = (dueInvoiceSum * 100) / total)
        : duePercent;
      openInvoiceSum > 0
        ? (openPercent = (openInvoiceSum * 100) / total)
        : openPercent;

      setGraphData({ duePercent, openPercent });
      const defaultColumns: Column[] = [
        {
          dataKey: 'open',
          dataKeyTitle: `A vencer R$ ${formatCurrency(
            openInvoiceSum.toString()
          )}`,
          colors: {
            variant: 'support-03',
            tone: '500'
          }
        },
        {
          dataKey: 'due',
          dataKeyTitle: `Vencidas R$ ${formatCurrency(
            dueInvoiceSum.toString()
          )}`,
          colors: {
            variant: 'support-04',
            tone: '500'
          }
        }
      ];

      const graphDataSource: DataProps[] = [
        {
          due: duePercent,
          open: openPercent
        }
      ];

      setColumns(defaultColumns);
      setDataSource(graphDataSource);
    };

    if (!graphData && duplicatesState.invoicesSummary) {
      initDuplicatesChart(duplicatesState.invoicesSummary);
    }
  }, [graphData, duplicatesState.invoicesSummary]);

  return (
    <>
      {duplicatesState.invoicesSummary && graphData && (
        <>
          <BarGraph
            barDataKey={'title'}
            layout={'vertical'}
            legendLayout={'vertical'}
            stacked={true}
            columns={columns}
            dataSource={dataSource}
            tooltipFormatter={(value: number | string) =>
              `${parseFloat(value.toString()).toFixed(2)}%`
            }
          ></BarGraph>
          <DuplicatesFooter>
            <span className="total">Total</span>
            <span>
              <strong>
                R${' '}
                {formatCurrency(
                  duplicatesState.invoicesSummary.totalInvoice.replace(/,/g, '')
                )}
              </strong>
            </span>
          </DuplicatesFooter>
        </>
      )}
    </>
  );
};

export default DuplicatesChart;
